import { useAppDispatch } from '~/redux/hooks'
import { TopicId } from '~/dashboard/utils/learningPath.utils'

import { useGenerateCurriculumCertificateMutation } from '../apis/curriculum.api'
import {
  emptyLastLevelInfo,
  setCurrentCertificateActionCreator,
  setLastLevelStatusInfoActionCreator,
  setShouldShowCertificateModalActionCreator,
} from '../slice/curriculum.slice'
import { GradeInfo } from '../types/mapping-quiz.types'
import { isCertificateClaimingApplicable } from '../utils/validateCountryCodeGrade'

export function useClaimCertificate(): {
  isLoading: boolean
  claimCertificate: (gradeInfo: GradeInfo, isV2?: boolean) => Promise<void>
} {
  const dispatch = useAppDispatch()

  const [generateCertificate, { isLoading }] = useGenerateCurriculumCertificateMutation()

  const claimCertificate = async (gradeInfo: GradeInfo): Promise<void> => {
    if (gradeInfo) {
      const shouldClaimCertificate = isCertificateClaimingApplicable({ countryCode: gradeInfo.countryCode })

      if (!shouldClaimCertificate) {
        return
      }
      const { countryCode, gradeId, gradeLevel, subject, subjectOrder, topicId, version, topicUUID } = gradeInfo
      const { data } = await generateCertificate({
        gradeId,
        countryCode,
        gradeLevel,
        subject,
        subjectOrder,
        topicId: topicId as TopicId,
        topicUUID,
        version,
      })
      const isCompleted = data?.isCompleted
      if (isCompleted) {
        dispatch(setCurrentCertificateActionCreator(data.certificate))
        dispatch(setLastLevelStatusInfoActionCreator(emptyLastLevelInfo))
        dispatch(setShouldShowCertificateModalActionCreator(true))
      }
    }
  }

  return { isLoading, claimCertificate }
}
